export interface ProductSummary {
  id: number;
  slug: string;
  isActive: boolean;
  name: string;
  shortDescription: string;
  imagePath: string;
  secondImage: string;
  quantity: number;
  sku: string;
  inStock: boolean;
  companyPriceID: number;
  price: number;
  priceFormatted: string;
  specialPrice: number;
  specialPriceFormatted: string;
  brandName: string;
  tax: number;
  videoURL: string;
  createdAt: Date;
  updatedAt: Date;
}

export const productSummaryFromResponse = (
  responseData: any,
): ProductSummary => ({
  id: responseData.id,
  slug: responseData.slug,
  isActive: responseData.is_active,
  name: responseData.name,
  shortDescription: responseData.short_description,
  imagePath: responseData.path,
  secondImage: responseData.second_image,
  quantity: responseData.qty,
  sku: responseData.sku,
  inStock: responseData.in_stock,
  companyPriceID: responseData.company_price_id,
  price: responseData.price,
  priceFormatted: responseData.price_formatted,
  specialPrice: responseData.special_price,
  specialPriceFormatted: responseData.special_price_formatted,
  brandName: responseData.brand_name,
  tax: responseData.tax,
  videoURL: responseData.video_url,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});
